import colors from "./colors";
import fontSize from "./fontSize";

const theme = {
  colors: colors,
  fontSize: fontSize,
};

export default theme;
